import { Star, StarHalf } from "lucide-react";

interface StarRatingProps {
  rating: number;
  maxRating?: number;
}

export function StarRating({ rating, maxRating = 5 }: StarRatingProps) {

  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = maxRating - Math.ceil(rating);

  return (
    <div className='flex gap-1'>
      {/* Full stars */}
      {Array.from({ length: fullStars }).map((_, i) => (
        <Star
          key={`full-${i}`}
          className='w-6 h-6 fill-oh-yellow text-oh-yellow'
        />
      ))}

      {/* Half star */}
      {hasHalfStar && (
        <StarHalf className='w-6 h-6 fill-oh-yellow text-oh-yellow' />
      )}

      {/* Empty stars */}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <Star key={`empty-${i}`} className='w-6 h-6 text-oh-yellow' />
      ))}
    </div>
  );
}
